<!-- eslint-disable vue/valid-v-model -->
<template>
  <v-card flat class="px-6">
    <v-row no-gutters>
      <v-col cols="12">
        <a type="primary" size="xsmall" @click="beforeLeave">
          <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
          {{ $t('message.actions.return') }}
        </a>
      </v-col>
    </v-row>

    <div class="grid__control">
      <div class="mb-4">
        <div class="body-bold-medium">
          {{ $t('message.pages.video.buttonsPage.buttonConfig') }}
        </div>
        <div
          class="body-regular-smaller neutral-40-light--text pt-2 pb-3 d-flex align-center"
        >
          {{ $t('message.pages.video.buttonsPage.buttonConfigDescription') }}
          <a target="_blank" type="secondary" class="ml-1" :href="leadArticle">
            <span>
              {{ $t('message.embedModal.knowMore') }}
            </span>
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </div>
      </div>

      <!-- Seção de Configurações Gerais -->
      <v-card flat tile style="background: transparent" class="mb-6">
        <v-col cols="12" class="px-4">
          <!-- <v-row
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
            class="pt-3"
          >
            <div style="display: grid">
              <span class="neutral-20-dark-text">{{
                $t('message.pages.video.buttonsPage.customHtml')
              }}</span>
              <a
                :href="$t('message.pages.video.buttonsPage.howToUseLink')"
                target="_blank"
                type="secondary"
              >
                <span class="body-bold-smaller"
                  >{{ $t('message.pages.video.buttonsPage.howToUse') }}
                </span>
                <v-icon
                  size="12"
                  style="vertical-align: middle; display: inline"
                  >mdi-open-in-new</v-icon
                ></a
              >
            </div>
            <v-switch
              v-model="buttonData.isCustomHtml"
              color="primary"
              class="ma-0 toggle-input"
              hide-details
            ></v-switch>
          </v-row> -->

          <!-- <v-row no-gutters class="mt-6" v-if="buttonData.isCustomHtml">
            <v-col cols="12" class="mb-2">
              {{ $t('message.pages.videoPlayerButtons.htmlCode') }}
            </v-col>
            <v-col cols="12">
              <v-textarea-legacy
                v-model="buttonData.codeHtml"
                :placeholder="$t('message.pages.video.buttonHtmlText')"
                outlined
                hide-details
              />
            </v-col>
          </v-row> -->

          <!-- Configurações normais do botão (escondidas quando HTML customizado está ativo) -->
          <template v-if="!buttonData.isCustomHtml">
            <v-row align="center">
              <span class="body-regular-small neutral-20-dark-text">{{
                $t('message.pages.video.buttonsPage.buttonPosition')
              }}</span>
              <v-col style="justify-items: flex-end" class="pr-0">
                <v-card
                  flat
                  height="38"
                  width="38"
                  class="border-rounded-circle"
                >
                  <v-row no-gutters>
                    <v-col
                      cols="4"
                      v-for="placement in buttonPlacements"
                      :key="placement.type"
                    >
                      <v-card
                        height="8px"
                        width="8px"
                        flat
                        class="rounded-circle"
                        :class="{
                          'primary-selected':
                            buttonData.selectedButtonPlacement ===
                            placement.type,
                        }"
                        style="margin: 2px"
                        @click="handleChangeButtonPlacement(placement.type)"
                      ></v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="5" class="pa-0 ma-0">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.video.buttonsPage.buttonText') }} </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0 pt-2">
                <v-input
                  style="font-size: 13px"
                  v-model="buttonData.title"
                  :counter="
                    isFocused
                      ? buttonData.selectedButtonSize === 'small'
                        ? 32
                        : buttonData.selectedButtonSize === 'medium'
                        ? 40
                        : 64
                      : false
                  "
                  :rules="[
                    rules.required,
                    rules.maxLength32,
                    rules.maxLength40,
                    rules.maxLength64,
                  ]"
                  @focus="isFocused = true"
                  @blur="isFocused = false"
                ></v-input>
              </v-col>
            </v-row>

            <v-row align="center" class="pt-3">
              <v-col cols="5" class="pa-0 ma-0">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.video.buttonsPage.size') }} </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0">
                <v-select
                  v-model="buttonData.selectedButtonSize"
                  :items="buttonSizeOptions"
                  dense
                  outlined
                  hide-details
                  style="font-size: 13px"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" class="pt-3">
              <v-col cols="5" class="pa-0 ma-0">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.live.action') }} </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0 pt-2 d-flex justify-end">
                <v-chip-group v-model="selectedAction">
                  <v-chip>
                    {{ $t('message.pages.video.buttonsPage.externalLink') }}
                  </v-chip>
                  <v-chip>
                    {{ $t('message.pages.video.buttonsPage.openVideo') }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <v-row align="center" class="pt-3" v-if="selectedAction == 0">
              <v-col cols="5" class="pa-0 ma-0">
                <span class="body-regular-small neutral-20-dark--text">
                  Link </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0 pt-2 justify-end">
                <v-input
                  style="font-size: 13px"
                  v-model="buttonData.link"
                  placeholder="https://"
                  :error="errors.link || errors.domain"
                  :error-messages="
                    errors.link
                      ? $t(
                          'message.banners.appOfflineBanner.modal.stepTree.linkShouldStartWith'
                        )
                      : errors.domain
                      ? $t(
                          'message.banners.appOfflineBanner.modal.stepTree.checkLink'
                        )
                      : ''
                  "
                  @input="checkIfDomainIsVald"
                  :rules="[noCommaRule, rules.required]"
                ></v-input>
              </v-col>
            </v-row>
            <v-row align="center" class="pt-3" v-if="selectedAction == 1">
              <template
                v-if="videoSelected && videoSelected.status === 'UPLOADING'"
              >
                <div class="video-loading-container">
                  <base-progress-circular />
                </div>
              </template>
              <template v-else>
                <v-col cols="5" class="pa-0 ma-0">
                  <span class="body-regular-small neutral-20-dark--text">
                    {{
                      $t('message.pages.video.buttonsPage.destinationVideo')
                    }} </span
                  ><br />
                </v-col>
                <v-col cols="7" class="pa-0 ma-0 pt-2 d-flex justify-end">
                  <base-btn
                    class="mr-2"
                    type="secondary"
                    size="small"
                    v-if="!buttonData.redirectVideoId"
                    @click="selectedLibrary"
                    >{{
                      $t('message.pages.video.buttonsPage.select')
                    }}</base-btn
                  >
                  <div v-else class="d-flex align-center justify-space-between">
                    <div
                      @click="openVideo()"
                      class="d-flex align-center"
                      style="gap: 16px; cursor: pointer"
                    >
                      <img
                        :src="
                          videoSelected.status === 'CONVERTING' ||
                          videoSelected.status === 'DRAFT'
                            ? require('@/assets/empty-preview.svg')
                            : videoSelected.preview
                        "
                        style="height: 32px; width: 48px; border-radius: 4px"
                      />
                      <span
                        class="regular-bold-smaller neutral-30-base--text video-title-truncated"
                      >
                        {{ videoSelected.title }}</span
                      >
                      <base-progress-circular
                        v-if="
                          videoSelected.status === 'CONVERTING' ||
                          videoSelected.status === 'DRAFT'
                        "
                      />
                    </div>
                    <base-btn
                      :disabled="loading"
                      v-bind="attrs"
                      v-on="on"
                      class="panda-icons --thumbnail d-flex align-center ml-2"
                      type="neutral"
                      @click="selectedLibrary"
                      ><v-icon
                        style="
                          font-size: 16px;
                          color: var(--neutral-40-light-light) !important;
                        "
                        >panda-edit</v-icon
                      ></base-btn
                    >
                  </div>
                </v-col>
              </template>
            </v-row>
            <v-row
              v-if="selectedAction == 0"
              class="pt-2"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div style="display: grid">
                <span class="body-regular-small neutral-20-dark-text">{{
                  $t('message.pages.video.buttonsPage.sendParameterInUrl')
                }}</span>
                <span class="body-regular-smaller neutral-40-light--text">{{
                  $t(
                    'message.pages.video.buttonsPage.sendParameterInURlExplain'
                  )
                }}</span>
                <a
                  :href="$t('message.pages.video.buttonsPage.knowMoreURL')"
                  target="_blank"
                  type="secondary"
                >
                  <span class="body-bold-smaller"
                    >{{ $t('message.pages.video.buttonsPage.knowMore') }}
                  </span>
                  <v-icon
                    size="12"
                    style="vertical-align: middle; display: inline"
                    >mdi-open-in-new</v-icon
                  ></a
                >
              </div>
              <v-switch
                v-model="buttonData.appendWebsiteQueryParams"
                color="primary"
                class="ma-0 toggle-input"
                hide-details
              ></v-switch>
            </v-row>
          </template>
        </v-col>

        <!-- Divisor (apenas quando não é HTML customizado) -->
        <v-row class="mx-n7 my-0" v-if="!buttonData.isCustomHtml">
          <v-divider class="mt-8"></v-divider>
        </v-row>

        <!-- Configurações de Cores (apenas quando não é HTML customizado) -->
        <v-col cols="12" class="px-4 mt-6" v-if="!buttonData.isCustomHtml">
          <v-row justify="center" align="center">
            <span class="body-label-caption neutral-60--text"> Cores </span>
            <v-spacer></v-spacer>
            <v-btn
              x-small
              icon
              @click="showingMenus.colors = !showingMenus.colors"
            >
              <v-icon v-if="showingMenus.colors">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-row>
          <template v-if="showingMenus.colors">
            <v-row align="center" class="pt-3">
              <v-col cols="5" class="pa-0 ma-0 pt-5">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.drm.drmApparence.colorText') }} </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0">
                <v-row align="center" class="pa-0 ma-0 mt-6 justify-end">
                  <span class="mr-2 label-text">{{
                    buttonData.textColor
                  }}</span>
                  <v-menu
                    v-model="showingMenus.textColorMenuOpen"
                    offset-x
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="buttonData.textColor"
                        style="
                          height: 16px !important;
                          width: 16px;
                          border-radius: 8px;
                          border: 1px solid #000;
                        "
                        :style="`transition: border-radius 200ms ease-in-out;background: ${buttonData.textColor};`"
                        v-on="on"
                        icon
                      ></v-btn>
                    </template>
                    <v-color-picker
                      v-model="buttonData.textColor"
                      flat
                      mode="hexa"
                      hide-mode-switch
                      :maxlength="7"
                    ></v-color-picker>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" class="pt-3 justify-space-between">
              <v-col cols="5" class="pa-0 ma-0 pt-5">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.drm.drmApparence.colorText') }}
                  (hover) </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0">
                <v-row align="center" class="pa-0 ma-0 mt-6 justify-end">
                  <span class="mr-2 label-text">{{
                    buttonData.textHover
                  }}</span>
                  <v-menu
                    v-model="showingMenus.textHoverColorMenuOpen"
                    offset-x
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="buttonData.textHover"
                        style="
                          height: 16px !important;
                          width: 16px;
                          border-radius: 8px;
                          border: 1px solid #000;
                        "
                        :style="`transition: border-radius 200ms ease-in-out;background: ${buttonData.textHover};`"
                        v-on="on"
                        icon
                      ></v-btn>
                    </template>
                    <v-color-picker
                      v-model="buttonData.textHover"
                      flat
                      mode="hexa"
                      hide-mode-switch
                      :maxlength="7"
                    ></v-color-picker>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" class="pt-3 justify-space-between">
              <v-col cols="5" class="pa-0 ma-0 pt-5">
                <span class="body-regular-small neutral-20-dark--text">
                  {{
                    $t('message.pages.drm.settingsForm.backgroundColor')
                  }} </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0">
                <v-row align="center" class="pa-0 ma-0 mt-6 justify-end">
                  <span class="mr-2 label-text">{{
                    buttonData.backgroundColor
                  }}</span>
                  <v-menu
                    v-model="showingMenus.backgroundColorMenuOpen"
                    offset-x
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="buttonData.backgroundColor"
                        style="
                          height: 16px !important;
                          width: 16px;
                          border-radius: 8px;
                          border: 1px solid #000;
                        "
                        :style="`transition: border-radius 200ms ease-in-out;background: ${buttonData.backgroundColor};`"
                        v-on="on"
                        icon
                      ></v-btn>
                    </template>
                    <v-color-picker
                      v-model="buttonData.backgroundColor"
                      flat
                      mode="hexa"
                      hide-mode-switch
                      :maxlength="7"
                    ></v-color-picker>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="center" class="pt-3 justify-space-between">
              <v-col cols="5" class="pa-0 ma-0 pt-5 justify-end">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.drm.settingsForm.backgroundColor') }}
                  (hover) </span
                ><br />
              </v-col>
              <v-col cols="7" class="pa-0 ma-0">
                <v-row align="center" class="pa-0 ma-0 mt-6 justify-end">
                  <span class="mr-2 label-text">{{
                    buttonData.backgroundHover
                  }}</span>
                  <v-menu
                    v-model="showingMenus.backgroundHoverColorMenuOpen"
                    offset-x
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="buttonData.backgroundHover"
                        style="
                          height: 16px !important;
                          width: 16px;
                          border-radius: 8px;
                          border: 1px solid #000;
                        "
                        class="rounded-pill border-slate"
                        :style="`transition: border-radius 200ms ease-in-out;background: ${buttonData.backgroundHover};`"
                        v-on="on"
                        icon
                      ></v-btn>
                    </template>
                    <v-color-picker
                      v-model="buttonData.backgroundHover"
                      flat
                      mode="hexa"
                      hide-mode-switch
                      :maxlength="7"
                    ></v-color-picker>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-card>
    </div>

    <!-- Portal para ações de salvamento -->
    <portal to="actions-footer">
      <div class="d-flex flex-row actions-row">
        <v-spacer></v-spacer>
        <v-tooltip max-width="184px" top :disabled="!withoutChanges">
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                type="tertiary"
                class="mr-2 px-4"
                text
                :disabled="withoutChanges"
                @click="handleUndoChanges"
              >
                {{ $t('message.actions.cancel') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
        <div class="pl-2">
          <base-btn
            type="primary"
            :loading="loading"
            :disabled="withoutChanges || !isValidForSave"
            width="150"
            @click="handleSave"
            :tooltip="
              !isValidForSave
                ? getValidationMessage
                : withoutChanges
                ? $t('message.noChanges')
                : ''
            "
          >
            <span class="px-5">{{ $t('message.actions.publish') }}</span>
          </base-btn>
        </div>
      </div>
    </portal>
    <add-video-destiny-funnel :funnelFolderId="currentVideoFolderId" />
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import playerApi from '@/services/playerApi'
import i18n from '@/translations/lang'
import { isEmpty } from '@aws-amplify/core'
import _ from 'lodash'
import {
  generateInsideButtonScript,
  getDefaultButtonMetadata,
  timeToSeconds as utilTimeToSeconds,
} from '@/utils/ctaGenerator'
import AddVideoDestinyFunnel from './AddVideoDestinyInteractions.vue'
import videosApi from '../../../services/videosApi'
import funnelApi from '@/services/funnelApi'
import ctaRedirectMixin from '@/mixins/ctaRedirectMixin'
import BaseProgressCircular from '@/components/BaseComponents/BaseProgressCircular.vue'

export default {
  name: 'VideoPlayerButtonInteraction',
  components: { AddVideoDestinyFunnel, BaseProgressCircular },
  mixins: [ctaRedirectMixin],
  data() {
    return {
      isFocused: false,
      isTimelineDragging: false,
      loading: false,
      rules: {
        required: (v) => (v && !!v) || this.$t('message.requiredFill'),
        maxLength32: (v) =>
          (v && v.length <= 32) || this.$t('message.maximumLength32'),
        maxLength40: (v) =>
          (v && v.length <= 40) || this.$t('message.maximumLength40'),
        maxLength64: (v) =>
          (v && v.length <= 64) || this.$t('message.maximumLength64'),
      },
      isExistentCta: false,
      initialButtonData: {},
      buttonData: {},
      selectedAction: 0,
      videoSelected: null,
      isHovering: false,
      showingMenus: {
        general: true,
        colors: true,
        advanced: false,
        textColorMenuOpen: false,
        textHoverColorMenuOpen: false,
        backgroundColorMenuOpen: false,
        backgroundHoverColorMenuOpen: false,
      },
      buttonSizeOptions: [
        {
          text: i18n.t('message.pages.drm.drmApparence.sizes.small'),
          value: 'small',
        },
        {
          text: i18n.t('message.pages.drm.drmApparence.sizes.medium'),
          value: 'medium',
        },
        {
          text: i18n.t('message.pages.drm.drmApparence.sizes.large'),
          value: 'large',
        },
      ],
      noCommaRule: (v) =>
        !v.includes(',') ||
        i18n.t('message.pages.folderSettings.invalidDomain'),
      errors: {
        link: false,
        text: false,
        days: false,
        domain: false,
      },
      buttonPlacements: [
        { type: 'topLeft', text: 'Topo a esquerda' },
        { type: 'topCenter', text: 'Topo centralizado' },
        { type: 'topRight', text: 'Topo a direita' },
        { type: 'midLeft', text: 'Meio a esquerda' },
        { type: 'midCenter', text: 'Meio centralizado' },
        { type: 'midRight', text: 'Meio a direita' },
        { type: 'bottomLeft', text: 'Fundo a esquerda' },
        { type: 'bottomCenter', text: 'Fundo centralizado' },
        { type: 'bottomRight', text: 'Fundo a direita' },
      ],
      buttonPositionOptions: [
        { text: 'Superior Esquerda', value: 'topLeft' },
        { text: 'Superior Centro', value: 'topCenter' },
        { text: 'Superior Direita', value: 'topRight' },
        { text: 'Meio Esquerda', value: 'midLeft' },
        { text: 'Meio Centro', value: 'midCenter' },
        { text: 'Meio Direita', value: 'midRight' },
        { text: 'Inferior Esquerda', value: 'bottomLeft' },
        { text: 'Inferior Centro', value: 'bottomCenter' },
        { text: 'Inferior Direita', value: 'bottomRight' },
      ],
    }
  },
  methods: {
    ...mapMutations('dashboard', ['UPDATE_VIDEO_TIMELINE_ITEMS']),
    ...mapMutations('video', [
      'UPDATE_LOADING_SAVE',
      'UPDATE_VIDEO_CONFIG_CTAS',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    openVideo() {
      if (!this.videoSelected || !this.videoSelected.id) {
        console.warn('Nenhum vídeo selecionado para abrir')
        return
      }

      try {
        const videoUrl = `${window.location.origin}/#/videos/${this.videoSelected.id}`

        const newWindow = window.open(videoUrl, '_blank')

        if (!newWindow) {
          console.warn(
            'Não foi possível abrir a nova aba. Verifique se o popup está bloqueado.'
          )
          window.location.href = videoUrl
        }
      } catch (error) {
        console.error('Erro ao abrir vídeo:', error)
        window.location.href = `${window.location.origin}/#/videos/${this.videoSelected.id}`
      }
    },
    loadInitialData() {
      this.buttonData = _.cloneDeep(getDefaultButtonMetadata())

      const videoConfigButtonItem = this.video?.config?.ctas
        ? this.video.config.ctas.find(
            (cta) => cta.id === this.$route.params.btnId
          )
        : {}
      this.isExistentCta = !!videoConfigButtonItem

      const timelineButtonItem = this.timelineItems.find(
        (item) => item.data.id === this.$route.params.btnId
      )

      if (timelineButtonItem && !_.isEmpty(timelineButtonItem)) {
        this.buttonData = {
          ...this.buttonData,
          ..._.cloneDeep(timelineButtonItem.data.metadata),
        }
        this.buttonData.id = timelineButtonItem.data.id
      }

      if (videoConfigButtonItem) {
        this.initialButtonData = _.cloneDeep(videoConfigButtonItem.metadata)
      } else {
        this.initialButtonData = _.cloneDeep(this.buttonData)
      }

      this.updateHasNoChangesState(this.withoutChanges)
    },

    handleUpdateCurrentTime() {
      const timelineItem = this.timelineItem
      if (timelineItem) {
        this.buttonData.startTime = timelineItem.data.metadata.startTime
        this.buttonData.endTime = timelineItem.data.metadata.endTime
        this.buttonData.duration = timelineItem.data.duration
      }
    },
    handleManualDrop(selectedItem) {
      this.buttonData.redirectVideoId = selectedItem.video_external_id
      this.buttonData.videoId = selectedItem.id
      this.videoSelected = selectedItem
    },
    selectedLibrary() {
      this.$root.$emit('openAddVideoDestinyFunnel', {
        onSelect: (selectedItem) => {
          this.handleManualDrop(selectedItem)
        },
      })
    },
    async getVideo() {
      try {
        const ret = await videosApi.getAVideo(this.buttonData.videoId)
        this.videoSelected = ret.data
      } catch (error) {
        if (error.response && error.response.status === 404) {
          return
        }
        this.videoSelected = null
      }
    },
    updatePlayerCtas() {
      const newTimelineItems = this.timelineItems.map((item) => {
        if (isEmpty(item)) return item
        if (item.data.id === this.buttonData.id) {
          item.data = {
            ...item.data,
            script: this.generatedScript,
            type: 'video',
            time: this.elementTimes.startTime,
            duration: this.elementTimes.duration,
            metadata: {
              ...this.buttonData,
              startTime: this.elementTimes.startTimeStr,
              endTime: this.elementTimes.endTimeStr,
            },
            title: this.buttonData.title,
            id: this.buttonData.id,
          }
        }
        return item
      })
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...newTimelineItems])
      this.$root.$emit('reloadPlayerCtas')
    },
    handleChangeButtonPlacement(placement) {
      this.buttonData.selectedButtonPlacement = placement
    },
    generateEditingCta() {
      const cta = {
        script: this.generatedScript,
        type: 'video',
        time: this.elementTimes.startTime,
        duration: this.elementTimes.duration,
        metadata: {
          ...this.buttonData,
          startTime: this.elementTimes.startTimeStr,
          endTime: this.elementTimes.endTimeStr,
        },
        title: this.buttonData.title,
        id: this.buttonData.id,
        maxZIndex: true,
      }

      if (this.buttonData.isCustomHtml) {
        cta.metadata.appendWebsiteQueryParams = false
      }

      return cta
    },

    async handleSave() {
      this.loading = true
      try {
        const ctaData = this.generateEditingCta()
        await playerApi.addCta(this.video.id, ctaData)
        this.isExistentCta = true
        this.initialButtonData = _.cloneDeep(this.buttonData)
        const timelineItem = this.timelineItems.find(
          (item) => item.data.id === this.$route.params.btnId
        )
        if (timelineItem) {
          timelineItem.isDraft = false
        }

        if (
          this.selectedAction === 1 &&
          this.buttonData.redirectVideoId &&
          this.video.funnel_id
        ) {
          await this.addVideoToFunnel()
        }

        this.handleSnackbar()
        this.$emit('showFooter', true)
      } catch (error) {
        console.error('Erro ao salvar botão:', error)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.errors.unexpectedError'),
          type: 'error',
        })
      }
      this.loading = false
    },
    checkIfDomainIsVald() {
      this.errors.domain = false
      this.errors.link = false

      if (!this.buttonData.link.startsWith('http')) {
        this.errors.link = true
        return false
      }

      try {
        const url = new URL(this.buttonData.link)
        if (url.protocol !== 'http:' && url.protocol !== 'https:') {
          this.errors.link = true
          return false
        }

        if (!url.hostname || url.hostname.trim() === '') {
          this.errors.link = true
          return false
        }

        return true
      } catch (error) {
        this.errors.link = true
        return false
      }
    },
    async handleDelete() {
      try {
        this.$root.$emit('updateTimelineLoading', true)
        const { data } = await playerApi.deleteCta(
          this.video.id,
          this.buttonData.id
        )
        this.UPDATE_VIDEO_CONFIG_CTAS(data.ctas)
        // this.UPDATE_GLOBAL_SNACKBAR({
        //   open: true,
        //   text: this.$t('message.ai.removeSuccess'),
        //   type: 'success',
        // })
        this.$root.$emit('updateTimelineLoading', false)
      } catch (error) {
        console.error('Erro ao deletar botão:', error)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.errors.unexpectedError'),
          type: 'error',
        })
        this.$root.$emit('updateTimelineLoading', false)
      }
    },

    handleSnackbar() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$t('message.changesSaved'),
        type: 'success',
      })
    },

    updateHasNoChangesState(val) {
      const timelineButtonItem = this.timelineItems.find(
        (item) => item.data.id === this.buttonData.id
      )
      if (timelineButtonItem) {
        timelineButtonItem.hasChanges = !val
        this.$root.$emit('reRenderTimelineItems')
      }
    },

    handleUndoChanges() {
      this.buttonData = _.cloneDeep(this.initialButtonData)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: this.$t('message.changesSaved'),
        type: 'success',
      })
    },

    async addVideoToFunnel() {
      try {
        const funnelId = this.video.funnel_id

        const funnelResponse = await funnelApi.getFunnel(funnelId)
        const funnel = funnelResponse.data.data

        const mainVideo = funnel.videos?.find((video) => video.is_first)

        if (mainVideo) {
          let x = mainVideo.front_coordinates?.x || 100
          let y = mainVideo.front_coordinates?.y || 100

          x += 500

          const allVideos = [
            ...funnel.videos.map((video) => ({
              id: video.id,
              front_coordinates: video.front_coordinates,
              is_first: video.is_first,
            })),
            {
              id: this.buttonData.videoId,
              front_coordinates: {
                x: x,
                y: y,
              },
              is_first: false,
            },
          ]
          await funnelApi.addVideosToFunnel(funnelId, allVideos)
        }
      } catch (error) {
        console.error('Erro ao adicionar vídeo ao Funnel:', error)
      }
    },

    beforeLeave() {
      this.$router.push({
        name: 'VideoPage',
        params: { id: this.$route.params.id },
      })
    },

    timeToSeconds: utilTimeToSeconds,
  },

  async mounted() {
    this.$emit('showFooter', true)
    this.$root.$on('handleDeleteButton', async () => {
      await this.handleDelete()
    })
    this.$root.$on('timelineDrag', (isDragging) => {
      this.isTimelineDragging = isDragging
    })
    this.$root.$on('manual-drop', (selectedItem) => {
      this.handleManualDrop(selectedItem)
    })
    this.$root.$on('video-upload-started', () => {
      this.videoSelected = { status: 'UPLOADING' }
    })
    this.$root.$on('video-upload-completed', async (videoId) => {
      if (videoId === this.buttonData.videoId) {
        await this.getVideo()
      }
    })
    this.loadInitialData()
    await this.getVideo()
    if (this.buttonData.redirectVideoId) {
      this.selectedAction = 1
    }
    this.$emit('showFooter', true)
  },

  beforeDestroy() {
    this.$root.$off('updatePlayerButton')
    this.$root.$off('handleDeleteButton')
    this.$root.$off('manual-drop')
    this.$root.$off('timelineDrag')
    this.$root.$off('video-upload-started')
    this.$root.$off('video-upload-completed')
  },

  computed: {
    ...mapState({
      video: (state) => state.video.video,
      timelineItems: (state) => state.dashboard.timelineItems,
    }),

    locale() {
      return this.$i18next.resolvedLanguage
    },

    leadArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/video-funnel-1k1xo/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/funnel-de-videos-bn0awo/'
      }
      return 'https://help.pandavideo.com/pt-br/article/funil-de-videos-yw6y69/'
    },

    withoutChanges() {
      return _.isEqual(this.buttonData, this.initialButtonData)
    },

    isValidForSave() {
      if (this.buttonData.isCustomHtml) {
        return (
          this.buttonData.codeHtml && this.buttonData.codeHtml.trim() !== ''
        )
      }

      const hasTitleValid =
        this.buttonData.title && this.buttonData.title.trim() !== ''

      if (this.selectedAction === 0) {
        return (
          hasTitleValid &&
          this.buttonData.link &&
          this.buttonData.link.trim() !== '' &&
          !this.errors.link
        )
      }

      if (this.selectedAction === 1) {
        return hasTitleValid && !!this.buttonData.redirectVideoId
      }

      return false
    },

    timelineItem() {
      return this.timelineItems.find(
        (item) => item.data.id === this.$route.params.btnId
      )
    },

    elementTimes() {
      if (!this.timelineItem)
        return {
          startTime: 0,
          duration: 10,
          startTimeStr: '00:00',
          endTimeStr: '00:10',
        }

      const startTime = this.timelineItem.data.metadata.startTime
      const startTimeInSeconds =
        parseInt(startTime.split(':')[0]) * 60 +
        parseInt(startTime.split(':')[1])

      const endTime = this.timelineItem.data.metadata.endTime
      const endTimeInSeconds =
        parseInt(endTime.split(':')[0]) * 60 + parseInt(endTime.split(':')[1])

      const duration = endTimeInSeconds - startTimeInSeconds
      return {
        startTime: startTimeInSeconds,
        duration,
        startTimeStr: startTime,
        endTimeStr: endTime,
      }
    },

    generatedScript() {
      return this.buttonData.isCustomHtml
        ? this.buttonData.codeHtml
        : generateInsideButtonScript(this.buttonData)
    },
    currentVideoFolderId() {
      return this.video?.folder_id || null
    },
    setMenuBoxColor() {
      return {
        backgroundColor: this.group.boxColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    getValidationMessage() {
      if (!this.buttonData.title || this.buttonData.title.trim() === '') {
        return this.$t('message.requiredFill')
      }
      if (
        this.selectedAction === 0 &&
        (!this.buttonData.link || this.buttonData.link.trim() === '')
      ) {
        return this.$t('message.requiredFill')
      }
      if (this.selectedAction === 1 && !this.buttonData.redirectVideoId) {
        return this.$t('message.requiredFill')
      }
      return ''
    },
    previewButtonStyle() {
      const sizeMap = {
        small: { padding: '18px 44px', fontSize: '16px' },
        medium: { padding: '22px 66px', fontSize: '22px' },
        large: { padding: '26px 78px', fontSize: '26px' },
      }

      const size = sizeMap[this.buttonData.selectedButtonSize] || sizeMap.small

      return {
        padding: size.padding,
        fontSize: size.fontSize,
        backgroundColor: this.isHovering
          ? this.buttonData.backgroundHover
          : this.buttonData.backgroundColor,
        color: this.isHovering
          ? this.buttonData.textHover
          : this.buttonData.textColor,
        border: 'none',
        borderRadius: '10px',
        textDecoration: 'none',
        fontFamily: 'Rubik, sans-serif',
        cursor: 'pointer',
        textAlign: 'center',
        transition: 'all 0.3s ease',
        fontWeight: 'bold',
      }
    },
  },

  watch: {
    selectedAction(newValue) {
      if (newValue === 0) {
        this.buttonData.redirectVideoId = ''
        this.buttonData.videoId = ''
        this.videoSelected = null
      } else if (newValue === 1) {
        this.buttonData.link = ''
      }
    },
    '$route.params.btnId': {
      handler() {
        if (this.$route.params.btnId) {
          this.loadInitialData()
        }
      },
      immediate: true,
    },
    '$route.path': {
      handler() {
        this.loadInitialData()
      },
    },
    'timelineItem.data.duration': {
      handler() {
        this.handleUpdateCurrentTime()
      },
    },
    'timelineItem.data.time': {
      handler() {
        this.handleUpdateCurrentTime()
      },
    },
    buttonData: {
      handler() {
        if (this.isTimelineDragging) return
        this.updatePlayerCtas()
      },
      deep: true,
    },
    withoutChanges: {
      handler(val) {
        this.updateHasNoChangesState(val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.rounded-circle:hover {
  background-color: grey;
}
.border-rounded-circle {
  border: 1px solid varFigma(neutral-95-lightest);
}
.rounded-circle {
  background: varFigma(neutral-80-lighter);
}
.backIcon {
  margin-right: 8px;
}
.primary-selected {
  background: varFigma(brand-60-base);
}
.grid__control {
  .menu__color {
    &:hover {
      background-color: varFigma(neutral-99);
    }
  }
}

.body-bold-medium {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  color: varFigma(neutral-20-dark);
}

.body-regular-smaller {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.neutral-40-light--text {
  color: varFigma(neutral-40-light) !important;
}

.label-text {
  color: varFigma(neutral-40-light);
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.button-preview {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.video-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 8px;
  background: varFigma(neutral-95-lightest);
  border-radius: 8px;
}

.video-title-truncated {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
</style>
